/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Chat: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M23 1H1C0.448 1 0 1.448 0 2V19C0 19.552 0.448 20 1 20H8.198L11.232 23.64C11.422 23.868 11.703 24 12 24C12.297 24 12.578 23.868 12.768 23.64L15.802 20H23C23.552 20 24 19.552 24 19V2C24 1.448 23.552 1 23 1ZM12 5C13.381 5 14.5 6.119 14.5 7.5C14.5 8.881 13.381 10 12 10C10.619 10 9.5 8.881 9.5 7.5C9.5 6.119 10.619 5 12 5ZM16.5 16H7.5V14.379C7.5 13.488 8.085 12.709 8.94 12.457C9.735 12.222 10.803 12 12 12C13.197 12 14.265 12.222 15.06 12.457C15.915 12.709 16.5 13.488 16.5 14.379V16Z'
      fill='currentColor'
    />
  </React.Fragment>
)
